/* eslint-disable */
import { getFlagValue, setFlagValue } from '../api';

API.LMSInitialize = function(input) {
  console.log('LMSInitialize::', input);
  var lesson_status = '';
  // already initialized or already finished
  if (getFlagValue('flagInitialized') || getFlagValue('flagFinished')) {
    return false;
  }

  API.LMSSetValue_F(
    'cmi.core._children',
    'student_id,student_name,lesson_location,credit,lesson_status,entry,exit,score,total_time,session_time,lesson_mode'
  );
  API.LMSSetValue_F(
    'cmi.interactions._children',
    'id,time,type,correct_responses,student_response,objectives'
  );
  API.LMSSetValue_F('scormVersion', '1.2');
  API.LMSSetValue_F('cmi.core.score._children', 'raw');
  API.LMSSetValue_F('cmi.core.student_id', SCORM.getValueFromLMS('cmi.core.student_id'));
  API.LMSSetValue_F('cmi.core.student_name', SCORM.getValueFromLMS('cmi.core.student_name'));

  API.LMSSetValue_F('adlcp:masteryscore', SCORM.getValueFromLMS('adlcp:masteryscore'));
  API.LMSSetValue_F('cmi.core.score.raw', SCORM.getValueFromLMS('cmi.core.score.raw'));

  API.LMSSetValue_F('cmi.launch_data', SCORM.getValueFromLMS('cmi.launch_data'));
  API.LMSSetValue_F('cmi.core.lesson_location', SCORM.getValueFromLMS('cmi.core.lesson_location'));

  var lesson_status = SCORM.getValueFromLMS('cmi.core.lesson_status') || 'not attempted';
  var lesson_mode = SCORM.getValueFromLMS('cmi.core.lesson_mode');
  if (lesson_mode === 'browse') {
    API.LMSSetValue_F('cmi.core.lesson_status', 'browsed');
  } else {
    API.LMSSetValue_F('cmi.core.lesson_status', lesson_status);
  }

  lesson_status = SCORM.getValueFromLMS('cmi.core.lesson_status');
  // if(lesson_status === 'not_attempted') {
  API.LMSSetValue_F('cmi.core.lesson_mode', 'normal');
  // }
  // else {
  if (lesson_status === 'completed' || lesson_status === 'passed' || lesson_status === 'failed') {
    API.LMSSetValue_F('cmi.core.lesson_mode', 'review');
  }

  API.LMSSetValue_F('cardId', SCORM.getValueFromLMS('cardId'));
  API.LMSSetValue_F('cardPid', SCORM.getValueFromLMS('cardPid'));
  API.LMSSetValue_F('cardPerformanceId', SCORM.getValueFromLMS('cardPerformanceId'));
  API.LMSSetValue_F('cardPerformanceComplete', SCORM.getValueFromLMS('cardPerformanceComplete'));

  API.LMSSetValue_F('cmi.suspend_data', SCORM.getValueFromLMS('cmi.suspend_data'));
  API.LMSSetValue_F('cmi.interactions', SCORM.getValueFromLMS('cmi.interactions'));

  // / progress and completion tracking
  API.LMSSetValue_F('cmi.core.credit', SCORM.getValueFromLMS('cmi.core.credit'));
  API.LMSSetValue_F('cmi.core.entry', SCORM.getValueFromLMS('cmi.core.entry'));

  // total seat time
  API.LMSSetValue_F('cmi.core.total_time', SCORM.getValueFromLMS('cmi.core.total_time'));

  // API.LMSSetValue_F('cmi.interactions._count',SCORM.getValueFromLMS('cmi.interactions._count'));
  // new session so clear pre-existing session time
  // API.LMSSetValue_F('cmi.core.session_time','0000:00:00');

  API.LMSSetValue_F('cmi.interactions._count', SCORM.getValueFromLMS('cmi.interactions._count'));

  // flagInitialized = true;
  setFlagValue('flagInitialized', true);
  return true;
};

API_1484_11.Initialize = function(input) {
  console.log('LMSInitialize::', input);
  // already initialized or already finished
  if (getFlagValue('flagInitialized') || getFlagValue('flagFinished')) {
    return false;
  }
  API.LMSSetValue_F('scormVersion', '2004');
  API.LMSSetValue_F(
    'cmi.core._children',
    'student_id,student_name,lesson_location,credit,lesson_status,entry,exit,score,total_time,session_time,lesson_mode'
  );
  API.LMSSetValue_F('cmi.core.score._children', 'raw');
  API.LMSSetValue_F('cmi.learner_id', SCORM.getValueFromLMS('cmi.learner_id'));
  API.LMSSetValue_F('cmi.learner_name', SCORM.getValueFromLMS('cmi.learner_name'));
  API.LMSSetValue_F('adlcp:masteryscore', SCORM.getValueFromLMS('adlcp:masteryscore'));
  API.LMSSetValue_F('cmi.launch_data', SCORM.getValueFromLMS('cmi.launch_data'));
  API.LMSSetValue_F('cmi.location', SCORM.getValueFromLMS('cmi.location'));

  var lesson_mode = SCORM.getValueFromLMS('cmi.mode');
  API.LMSSetValue_F('cmi.mode', lesson_mode);
  // if(lesson_mode === 'browse') {
  // 	API.LMSSetValue_F('cmi.core.lesson_status', 'browsed');
  // } else {
  // 	API.LMSSetValue_F('cmi.core.lesson_status', lesson_status);
  // }

  // lesson_status = SCORM.getValueFromLMS('cmi.core.lesson_status');
  // if(lesson_status === 'not_attempted') {
  // 	API.LMSSetValue_F('cmi.core.lesson_mode','normal');
  // }
  // else {
  // 	API.LMSSetValue_F('cmi.core.lesson_mode','review');
  // }

  API.LMSSetValue_F('cardId', SCORM.getValueFromLMS('cardId'));
  API.LMSSetValue_F('cardPid', SCORM.getValueFromLMS('cardPid'));
  API.LMSSetValue_F('cardPerformanceId', SCORM.getValueFromLMS('cardPerformanceId'));
  API.LMSSetValue_F('cardPerformanceComplete', SCORM.getValueFromLMS('cardPerformanceComplete'));

  API.LMSSetValue_F('cmi.suspend_data', SCORM.getValueFromLMS('cmi.suspend_data'));
  API.LMSSetValue_F('cmi.success_status', 'unknown');

  // / progress and completion tracking
  API.LMSSetValue_F('cmi.credit', SCORM.getValueFromLMS('cmi.credit'));
  API.LMSSetValue_F('cmi.score.raw', SCORM.getValueFromLMS('cmi.score.raw'));

  API.LMSSetValue_F('cmi.core.lesson_status', SCORM.getValueFromLMS('cmi.core.lesson_status'));
  API.LMSSetValue_F('cmi.progress_measure', SCORM.getValueFromLMS('cmi.progress_measure'));
  API.LMSSetValue_F('cmi.completion_status', SCORM.getValueFromLMS('cmi.completion_status'));

  API.LMSSetValue_F('cmi.entry', SCORM.getValueFromLMS('cmi.entry'));

  // total seat time
  API.LMSSetValue_F('cmi.total_time', SCORM.getValueFromLMS('cmi.total_time'));

  setFlagValue('flagInitialized', true);
  return true;
};
